<template>
<div class="material-list">
  <div class="row action-section">
    <div class="col-4">
      <div class="action-title">MATERIAL LIST</div>
    </div>
    <div class="col-8 right">
      <!-- <ul class="action-list">
        <li><span class="action">
      <svgicon name="documentregular" width="10" height="10" :original="true" />
      Documents
    </span></li>
      </ul> -->
    </div>
  </div>
  <div class="table-header" v-if="dispatch.materials.length">
  <div class="table-throw">
    <div class="table-th w200">CODE</div>
    <div class="table-th w200">NAME</div>
    <div class="table-th w200">QUANTITY</div>
    <div class="table-th w200">WEIGHT (KG)</div>
    <div class="table-th w200">Shortage</div>
    <div class="table-th w200">Damage</div>
    <div class="table-th w200">Leakage</div>
    <div class="table-th w200">Excess</div>
    <div class="table-th w200">Carton Damage</div>
  </div>
</div>

  <div class="table-scroll">
    <Row
    v-for="material in dispatch.materials"
    :material="material"
    :isPodCompleted="isPodCompleted"
    :isOtpGenerated="isOtpGenerated"
    v-bind:key="material.id"
    />

  </div>
  <div class="dispatch" v-if="dispatch.consignee.delivery_date === ''">
    <!-- <div class="dispatch-text">
      Materials recived ontime and without damages
    </div>
    v-if="!isOtpGenerated"
    -->
    <button  type="button" @click="$emit('pod');" class="btn btn-primary">CONFIRM</button>
    <!--  v-if="isOtpGenerated" -->
     <div class="col-12 pull-right optsection" >
      <div class="action-title">Enter Otp</div>
      <div class="enter-otp">
        <input
        type="number"
        min="0"
        v-model="otp_number"
        />
        <button type="button" @click="$emit('otpSubmit', otp_number);" class="btn btn-primary">submit</button>
      </div>
    </div>
  </div>

  <div v-if="dispatch.consignee.delivery_date !=''" class="date-section">
    POD Submitted on
    <span class="date-style">
      {{dispatch.consignee.delivery_date | moment("DD MMM YYYY")}}
    </span>
  </div>
</div>
</template>

<script>
import Row from './Row';

export default {
  props:
  {
    dispatch: Object,
    generateOtp: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Row,
  },
  data() {
    return {
      otp_number: '',
    };
  },
  computed: {
    isPodCompleted() {
      return !!this.dispatch.consignee.delivery_date;
    },
    isOtpGenerated() {
      return this.generateOtp;
    },
  },
  methods: {

  },
};
</script>
<style lang="scss" scoped>
@import "~@common/styles-shipper/settings";
.material-list{
  .date-section{
    font-size: 1.4rem;
  }
  .date-style{
    font-family:$fontBold;
  }
  .table-header{
    border-color: transparent;
        border-bottom: 0.5px solid #404040;
        .table-row{
          border-left: 1px solid transparent;
          border-right: 1px solid transparent;
        }
  }
}
.material-list {
    .table-scroll {
        overflow-y: auto;
        //height: calc(32vh - 10px);
        margin-bottom: 25px;
        border-top: 1px solid #404040;
    }
    .table-header {
        border-color: transparent;
        border-bottom: 1px solid #404040;
        .table-row {
            border-left: 1px solid transparent;
            border-right: 1px solid transparent;
        }
    }
    .dispatch {
        float: right;
        margin: 0px 10px 20px;
        text-align: right;
        width:100%;
        &-text {
            color: #404040;
            font-size: 1.4rem;
            line-height: 30px;
            .btn-primary {
                float: right;
            }
        }
    }
    .action {
        &-section {
            .right {
                text-align: right;
                float: right;
            }
        }
        &-title {
            color: #3A687D;
            font-family:$fontSemibold;
            font-size: 1.6rem;
            margin-bottom: 10px;
        }
        &-list {
            @extend %list-unstyled;
            padding: 5px 0 20px;
            li {
                display: inline-block;
                padding: 0 0 0 20px;
                font-size: 1.2rem;
                color: #376F99;
                font-family:$fontBold;
            }
        }
    }
}
.optsection{
    margin: 20px 0;
    padding: 0 5px;
    .action-title{
      font-size: 1.4rem;
    }

    .btn-primary  {
    margin-right: 0px;
    }

}
.enter-otp{
  input{
        width: 8%;
    margin-left: auto;
    margin: 5px 0 20px auto;
    text-align: right;
    font-family:$fontSemibold;
    font-size: 1.4rem;
    color: #404040;
  }
}
</style>
